<template>
  <div class="user-type-selector" v-if="userTypes.length">
    <template v-if="hasMultipleUserTypes">
      <label class="selector-label">Act as</label>
      <select
        :value="selectedUserType"
        aria-label="Select active user type"
        class="selector-select"
        @change="onChange"
      >
        <option
          v-for="t in formattedUserTypes"
          :key="t.value"
          :value="t.value"
        >
          {{ t.label }}
        </option>
      </select>
    </template>
    <div v-else-if="selectedUserType" class="viewing-as">
      <span class="secondary-text">Viewing as: </span>
      <span class="cabin-family semi-bold">{{ selectedUserTypeLabel }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserTypeSelector',
  computed: {
    userTypes() {
      return this.$store.getters.user_types || [];
    },
    selectedUserType() {
      return this.$store.getters.selectedUserType;
    },
    hasMultipleUserTypes() {
      return this.$store.getters.hasMultipleUserTypes;
    },
    formattedUserTypes() {
      return this.userTypes.map((type) => ({
        value: type,
        label: this.formatTypeLabel(type),
      }));
    },
    selectedUserTypeLabel() {
      return this.formatTypeLabel(this.selectedUserType);
    },
  },
  methods: {
    formatTypeLabel(type) {
      if (!type) return '';
      return type
        .split('-')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
    },
    async onChange(e) {
      const type = e.target && e.target.value;
      if (!type || !this.userTypes.includes(type)) return;
      const isOptingInToSmartMina = type === 'smart-mina'
        && !this.$store.state.user_types.includes('smart-mina');
      if (isOptingInToSmartMina) {
        try {
          await this.$store.dispatch('optInToSmartMina');
          this.$emit('change', type);
        } catch {
          e.target.value = this.selectedUserType;
        }
        return;
      }
      this.$store.commit('set_selected_user_type', type);
      this.$emit('change', type);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-type-selector {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;

  .selector-label {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #EE0E4C;
    font-family: 'Cabin', sans-serif;
    white-space: nowrap;
    line-height: 1;
    display: flex;
    align-items: center;
  }

  .selector-select {
    appearance: none;
    -webkit-appearance: none;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23EE0E4C' stroke-width='1.8' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 0.65rem center;
    border: 1.5px solid #EE0E4C;
    border-radius: 20px;
    color: #1a1a2e;
    font-family: 'Cabin', sans-serif;
    font-size: 13px;
    font-weight: 600;
    padding: 0.3rem 2rem 0.3rem 0.85rem;
    cursor: pointer;
    outline: none;
    transition: box-shadow 0.15s ease;

    &:focus {
      box-shadow: 0 0 0 3px rgba(238, 14, 76, 0.15);
    }
  }

  .viewing-as {
    font-size: 13px;
    .secondary-text {
      color: #6B6B6B;
    }
  }
}
</style>
